<template>
  <div class="policy_guidelines">
    <img src="../../assets/imgs/policy_guidelines/header.png" alt="" />
    <div class="main">
      <div class="left-p">
        <ul class="law-list" style="padding-left: 0px;">
          <li class="on">
            <a title="相关政策+" class="addprev">相关政策<img class="iconleft iconleftadd" src="../../assets/imgs/policy_guidelines/downus.png" alt=""></a>
            <ul class="third-nav">
                <li class="on"><a title="最新政策">最新政策</a></li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="list">
        <div class="newscenter">
          <div class="item" v-for="(item,index) in list" :key="index" @click="goDetail(item.id)">
            <div class="wordright">
              <p class="wordone">{{item.title}}</p>
              <p class="wordtwo">{{item.remark}}</p>
              <div class="time">
                <div class="imgtime">
                  <img src="../../assets/imgs/policy_guidelines/clock.png" alt="">
                </div>
                <div class="numtime">
                  <span>{{$moment(item.releaseTime).format("YYYY-MM-DD HH:MM:SS")}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="pageSize"
        layout="prev, pager, next, total, jumper"
        :total="total"
        style="text-align: center;">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import * as guideApi from '@/api/guidelines'
export default {
  data() {
    return {
      list: [],
      page: 1,
      pageSize: 10,
      total: null,
    };
  },

  created(){
    this.getList()
  },

  methods: {
    //获取新闻列表
    async getList(){
      let param = {
        page: this.page,
        pageSize: this.pageSize
      }
      const res = await guideApi.getGuideList(this.sendParam(param));
      let result = this.paramDecrypt(res)
      if(result.code == 200){
        this.list = result.data
        this.total = result.pageInfo.total
      } else {
        this.$message.error(result.msg);
      }
    },
    //跳转到新闻详情
    goDetail(id){
      this.$router.push({
        path: "guide_detail",
        query: { id: id }
      })
    },
    //切换页码
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    }
  }
  
}
</script>

<style lang="less" scoped>
ul li{
  list-style: none;
}
a{
  text-decoration: none;
}
.policy_guidelines{
  width: 100%;
  height: 100%;
  background-color: #f3f3f3;
  img{
    width: 100%;
    height: auto;
  }
  .main{
    background: #fff;
    width: 1100px;
    min-height: 486px;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 6px;
    padding: 20px 15px;
    .left-p{
      min-height: 200px;
      float: left;
      background: #FFFFFF;
      box-shadow: 0 10px 20px 0 rgb(119 154 241 / 5%), 0 8px 16px 2px rgb(119 154 241 / 8%);
      min-height: 200px;
      border-radius: 8px;
      .law-list li {
        line-height: 41px;
        background: #F5F8FD;
        a {
          display: inline-block;
          padding-left: 33px;
          width: 112px;
          background: url(../../assets/imgs/policy_guidelines/newicon.png) 12px center no-repeat;
          background-size: auto 14px;
          font-size: 15px;
          letter-spacing: 0;
          vertical-align: middle;
          .iconleft {
            width: 11px;
            height: 6px;
            float: right;
            margin-right: 8px;
            margin-top: 17px;
          }
        }
        .third-nav {
          padding-bottom: 10px;
          background: #fff;
          padding-left: 0px;
        }
        .on a {
          margin-left: 10px;
          box-shadow: 0 4px 10px rgb(36 62 99 / 15%);
          background: #2CAEFF;
          background: linear-gradient(189deg, #589DFF, #81C3FF, #67B9FF);
          text-decoration: none;
          color: #fff;
        }
        a {
          font-size: 14px;
          height: 34px;
          line-height: 34px;
          color: #253f63;
          display: inline-block;
          position: relative;
          transition: all .2s ease;
        }
      }
    }
    .list{
      margin-left: 180px;
      .newscenter{
        width: 100%;
        padding: 0 10px 20px;
        min-height: 400px;
        background: #ffffff;
        box-sizing: border-box;
        border-radius: 6px;
        .item{
          margin-top: 0px;
          height: auto;
          padding:10px 0 15px;
          border-bottom: 1px solid #E7E7E7;
          cursor: pointer;
          .wordright{
            width:860px;
            padding:0 15px;
            box-sizing: border-box;
            .wordone{
              font-family: PingFangSC-Medium;
              font-size: 16px;
              font-weight: bold;
              color:  #070A2D;
              letter-spacing: 0;
              display:block;
              text-overflow:ellipsis;
              white-space:nowrap;
              overflow:hidden;
              line-height:30px;
              margin: unset;
            }
            .wordtwo{
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #999999;
              letter-spacing: 0;
              line-height:20px;
              display:block;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;
              width: 98%;
              margin: unset;
            }
            .time{
              font-size:0;
              margin-top:8px;
              .imgtime{
                display: inline-block;
                vertical-align: middle;
                width:14px;
                height:14px;
                .imgtime img{
                  width:100%;
                  height:100%;
                }
              }
              .numtime{
                display: inline-block;
                vertical-align: middle;
                span{
                  padding-left: 4px;
                  font-family: PingFangSC-Regular;
                  font-size: 12px;
                  color: #999;
                  letter-spacing: 0;
                }
              }
            }
          }
        }
        .item:hover{
          box-shadow:0 -4px 16px 0 rgba(119,154,241,0.04), 0 8px 16px 2px rgba(119,154,241,0.20);;
          border-radius: 6px;
        }
        .item:hover .wordright .wordone{
          color: #2981EE;
        }
        .item:hover .wordright .wordtwo{
          color: #2981EE;
        }

      }

    }
  }
}
</style>
